import * as React from "react";
import { Alert, Button } from "react-bootstrap";
import styled from "styled-components";

const Description = styled.p`
	white-space: pre-wrap;
`;

const CodeList = styled(Alert)`
	font-family: monospace;
	text-align: center;
`;

const ButtonArea = styled.div`
	display: flex;
	gap: 8px;
	justify-content: flex-end;
`;

export type MFASetupRecoveryCodesProps = {
	onComplete: () => void;
	recoveryCodes: string[];
};

/**
 * リカバリコードの表示
 * - この画面でしか表示されないため、コピー・ダウンロードできるようにする
 */
export const MFASetupRecoveryCodes = React.memo((props: MFASetupRecoveryCodesProps) => {
	const { onComplete, recoveryCodes } = props;
	const [copied, setCopied] = React.useState<boolean>(false);

	const onCopy = React.useCallback(() => {
		navigator.clipboard
			?.writeText(recoveryCodes.join("\n"))
			.then(() => setCopied(true))
			.catch(() => setCopied(false));
	}, [recoveryCodes]);
	const onDownload = React.useCallback(() => {
		const blob = new Blob([recoveryCodes.join("\n")], { type: "text/plain" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = "testit-recovery-codes.txt";
		a.click();
		URL.revokeObjectURL(url);
	}, [recoveryCodes]);

	return (
		<>
			<Description>
				認証アプリを利用できない場合に使用できるリカバリコードを発行しました。
				<br />
				<b>リカバリコードはこの画面でのみ表示されます。</b>必ず安全な場所に保存してください。
				<br />
				リカバリコードは1つにつき1回のみ使用できます。
			</Description>
			<CodeList variant={"secondary"}>
				{recoveryCodes.map((recoveryCode) => (
					<div key={recoveryCode}>{recoveryCode}</div>
				))}
			</CodeList>
			<ButtonArea>
				<Button variant="outline-dark" onClick={onCopy}>
					{copied ? "コピーしました" : "コピー"}
				</Button>
				<Button variant="outline-dark" onClick={onDownload}>
					ダウンロード
				</Button>
				<Button variant="dark" onClick={onComplete}>
					完了
				</Button>
			</ButtonArea>
		</>
	);
});
